module.exports = __webpack_public_path__ + "static/media/abisLogo.1ac03be1.svg";